import { Typography, useMediaQuery } from "@mui/material";
import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import CommonTextField from "../../../component/Input";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { CustomizeSpan } from "../../jobs/style";

export default function PreScreenQuestion({ disabled }) {
  const { values, errors, setFieldValue, handleChange, touched } =
    useFormikContext();
  const lg = useMediaQuery("(min-width:767px)");
  const debounceTimer = React.useRef(null);
  const [questionData, setQuestionData] = useState(
    values["pre_screen_question_answers"]
  );
  useEffect(() => {
    setQuestionData(values["pre_screen_question_answers"]);
  }, [values]);

  const handleListChange = (e, index) => {
    const newAnswer = e.target.value;
    const updatedQuestions = questionData.map((item, i) =>
      i === index ? { ...item, answer: newAnswer } : item
    );

    setQuestionData(updatedQuestions);

    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      setFieldValue("pre_screen_question_answers", updatedQuestions);
    }, 400);
  };

  console.log(questionData, "sfskfkjsjfjsfnjsjkfjsk");

  return (
    <CommonGrid2 container spacing={2.5}>
      {questionData &&
        questionData.map((item, index) => (
          <CommonGrid2
            item
            size={12}
            display={"flex"}
            flexDirection={"column"}
            gap={"5px"}
          >
            <Typography variant={lg ? "h6" : "body1"}>
              {item.question}
              <CustomizeSpan color={"red"}> *</CustomizeSpan>
            </Typography>

            <CommonTextField
              placeholder={"Enter the answer"}
              padding="13px"
              multiline
              minRows={1}
              maxRows={20}
              disabled={disabled}
              error={Boolean(
                errors["pre_screen_question_answers"]?.[index]?.answer
              )}
              fontSize={lg ? "16px" : "14px"}
              placeholderFontSize={lg ? "15px" : "14px"}
              helperText={
                errors["pre_screen_question_answers"]?.[index]?.answer
              }
              value={item.answer}
              onChange={(e) => handleListChange(e, index)}
              customStyle={{
                "& .MuiInputBase-root": {
                  padding: "0px",
                },
              }}
            />
          </CommonGrid2>
        ))}
    </CommonGrid2>
  );
}
